import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "/api"; 

export const registerUser = async (data) => {
  return await axios.post(`${BASE_URL}/signup`, data);
};

export const loginUser = async (data) => {
  return await axios.post(`${BASE_URL}/login`, data);
};

export const getTasks = async (token) => {
  return await axios.get(`${BASE_URL}/tasks`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const updateTask = async (id, data, token) => {
  return await axios.put(`${BASE_URL}/tasks/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const deleteTask = async (id, token) => {
  return await axios.delete(`${BASE_URL}/tasks/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const createTask = async (data, token) => {
  return await axios.post(`${BASE_URL}/tasks`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
